import { render, staticRenderFns } from "./search.vue?vue&type=template&id=4368c7b2&scoped=true&lang=pug&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=4368c7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368c7b2",
  null
  
)

component.options.__file = "search.vue"
export default component.exports